import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Chapters from './components/Chapters';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ExitPopup from './components/ExitPopup';

function App() {
  return (
    <div className="bg-brand-black min-h-screen text-white font-sans selection:bg-brand-yellow selection:text-brand-black">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Chapters />
        <Testimonials />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <ExitPopup />
    </div>
  );
}

export default App;